import { getExperiment } from '@eventbrite/statsig';
/**
 * Gets the experiment treatment value for the promoted results carousel test.
 * This function determines whether the promoted event carousel should be shown in search results.
 * Link to experiment: https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/experiments/ads_promoted_search_result_carousel/setup
 * @returns {boolean} True if the promoted event carousel should be shown, false otherwise
 */

export const isPromotedEventCarouselEnabled = () => {
    const shouldShowPromotedEventCarousel = getExperiment(
        'ads_promoted_search_result_carousel',
        'show_search_result_ad_carousel',
        false,
    );
    return shouldShowPromotedEventCarousel;
};
